<template>
  <div class="container-fluid inbox-wrapper">
    <transition name="fade">
      <div v-if="loadingData === true" class="loading">
        <div class="loading-icon">
          <fa icon="sync-alt" spin/>
        </div>
        <div class="loading-text">
          Loading messages...
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="loadingChanges" class="loading-changes"></div>
    </transition>
    <div v-if="inboxZero === true" class="inbox-zero">
      <p>Congrats! You've reached <em>inbox <strong>zero</strong>!</em></p>
      <div class="big-zero">0</div>
    </div>
    <div v-if="loadingData === false && inboxZero === false" >
      <div v-show="showActions" class="actions-wrapper">
        <div class="inbox-actions-bar">
          <ul class="inbox-actions">
            <MessageActions :messageIds="selectedIds" :hasTicket="true" :inbox="true" />
          </ul>
        </div>
      </div>
      <b-alert :show="assigned_user.hasOwnProperty('full_name')" dismissible @dismissed="assigned_user = {}">
        Showing messages assigned to {{assigned_user.full_name}}
      </b-alert>
      <table class="inbox-table" id="">
        <colgroup>
          <col class="td-flags">
          <col class="check-column">
        </colgroup>
        <thead v-if="!mobile" id="tbl-head">
          <tr>
            <th class="check-column" colspan="2">
              <b-check id="head-checkbox"
                      v-model="selectAll">
              </b-check>
            </th>
            <th class="customer-column">
              <span>Customer </span>
              <span @click="sort('customer')">
                <fa icon="arrows-alt-v" v-if="sortCol !== 'customer'"/>
                <fa icon="long-arrow-alt-down" v-if="sortOrder === 'asc' && sortCol === 'customer'"/>
                <fa icon="long-arrow-alt-up" v-if="sortOrder === 'desc' && sortCol === 'customer'"/>
              </span>
            </th>
            <th class="conversation-column">
              <span>Conversation</span>
              <span @click="sort('subject')">
                <fa icon="arrows-alt-v" v-if="sortCol !== 'subject'"/>
                <fa icon="long-arrow-alt-down" v-if="sortOrder === 'asc' && sortCol === 'subject'"/>
                <fa icon="long-arrow-alt-up" v-if="sortOrder === 'desc' && sortCol === 'subject'"/>
              </span>
            </th>
            <th class="reply-column">
            </th>
            <th class="ticket-id-column">
              <span>ID</span>
              <span @click="sort('id')">
                <fa icon="arrows-alt-v" v-if="sortCol !== 'id'"/>
                <fa icon="long-arrow-alt-down" v-if="sortOrder === 'asc' && sortCol === 'id'"/>
                <fa icon="long-arrow-alt-up" v-if="sortOrder === 'desc' && sortCol === 'id'"/>
              </span>
            </th>
            <th v-if="hasUserColumn" class="user-column">
              <span @click="showUserSelect = !showUserSelect" v-b-tooltip.hover.bottom title="Filter users">User</span>
              <SingleUserSelector v-if="showUserSelect" v-on:user-change="assigned_user = $event" v-on:user-remove="assigned_user = {}" :parent="{user: assigned_user}"/>
            </th>
            <th class="time-column">
              <span>Last Updated</span>
              <span @click="sort('updated_at')">
                <fa icon="arrows-alt-v" v-if="sortCol !== 'updated_at'"/>
                <fa icon="long-arrow-alt-down" v-if="sortOrder === 'desc' && sortCol === 'updated_at'"/>
                <fa icon="long-arrow-alt-up" v-if="sortOrder === 'asc' && sortCol === 'updated_at'"/>
              </span>
            </th>
            <th v-if="myInbox" class="mailbox-column">
              <span>Mailbox</span>
            </th>
          </tr>
        </thead>
        <tbody id="tbl-body">
          <tr v-for="message in messages" :key="message.id" :id="'inbox-tr-message' + message.id" :class="message.status === 'active' ? 'active' : 'pending'">
            <b-popover v-if="viewReplyClass(message)" :target="'inbox-tr-message' + message.id" triggers="hover">
              <img v-for="(replier, key, i) in message.message_state.editors"
                   :key="'avatar-reply'+replier.user_id"
                   v-if="(parseInt(replier.user_id) !== currentUser.id) && i < 3"
                   :src="replier.avatar_url"
                   class="user-avatar replying">
              <img v-for="(viewer, key, i) in message.message_state.viewers"
                   :key="'avatar-view'+viewer.user_id"
                   v-if="showViewerAvatar(viewer.user_id, i, message)"
                   :src="viewer.avatar_url"
                   class="user-avatar viewing">
            </b-popover>
            <td class="td-flags">
              <div class="message-flags">
                <div :class="viewReplyClass(message)" class="flag">
                </div>
              </div>
            </td>
            <td v-if="!mobile" class="check-column" @click="shiftClick($event)">
              <b-check id=""
                      v-model="selectedIds"
                      :value="message.id"
                      :unchecked-value="null">
              </b-check>
            </td>
            <td class="customer-column">
              <router-link :to="{name: 'Message', params: { id: message.id } }">
                {{getCustomerName(message)}}
              </router-link>
            </td>
            <td class="conversation-column">
              <Tags :tags="message.tags" :index="true"/>
              <router-link :to="{name: 'Message', params: { id: message.id } }">
                <span class="conversation-title">{{message.subject}}</span>
                <p class="preview">{{message.preview_content}}</p>
              </router-link>
            </td>
            <td class="reply-column">
              <router-link :to="{name: 'Message', params: { id: message.id } }">
                <b-badge :class="message.merged ? 'reply-tag-merged' : 'reply-tag'">{{message.threads_count}}</b-badge>
              </router-link>
            </td>
            <td v-if="!mobile" class="ticket-id-column">
              <router-link :to="{name: 'Message', params: { id: message.id } }">
                {{message.id}} <fa icon="tasks" v-if="message.ticket_id" v-b-tooltip :title="'Ticket ID: ' + message.ticket_id"/>
                <fa icon="tasks" v-if="message.merged_ticket_id" v-b-tooltip :title="'Merged Ticket ID: ' + message.merged_ticket_id"/>
              </router-link>
            </td>
            <td v-if="hasUserColumn" class="user-column">
              <template v-if="message.user">
                <img v-if="message.user.avatar_url" class="user-avatar" :src="message.user.avatar_url" v-b-tooltip.hover.left :title="message.user.full_name"/>
                <span v-else class="icon-missing">
                  <fa icon="user-circle"/>
                </span>
              </template>
              <template v-else>
                <span class="icon-missing">
                  <fa icon="question-circle"/>
                </span>
              </template>
            </td>
            <td class="time-column">
              <router-link v-if="message.last_thread_date"
                           v-b-tooltip.hover.left :title="detailedDate(message.last_thread_date)"
                          :to="{name: 'Message', params: { id: message.id } }">
                {{prettyDate(message.last_thread_date)}}
              </router-link>
              <router-link v-else :to="{name: 'Message', params: { id: message.id } }">
                {{prettyDate(message.created_at)}}
              </router-link>
            </td>
            <td v-if="myInbox" class="mailbox-column">
              <router-link :to="{name: 'Inbox', params: { id: message.mailbox_id } }">{{mailboxName(message.mailbox_id)}}</router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="totals-row">
        <span class="total-conversation">{{totalMessages}}</span><span> total conversations | </span>
        <template v-if="activeFolder !== 'closed'">
          <span class="total-active">{{active}}</span><span> total active |</span>
        </template>
        <span class="viewing-text"> Viewing </span><span class="range1 viewing-text">{{ pageMin }}</span>
        <span class="viewing-text">-</span>
        <span class="range2 viewing-text">{{ pageMax }}</span>
      </div>
      <div class="pagination-row">
        <template v-if="page !== 1">
          <span class="all-previous" @click="setPage(1)"><span class="oi oi-chevron-left"></span><span class="oi oi-chevron-left"></span></span>&nbsp;
          <span class="previous" @click="setPage(page - 1)"><span class="oi oi-chevron-left" ></span></span>&nbsp;
        </template>
        <template v-if="pageMax < totalMessages">
          <span class="next" @click="setPage(page + 1)"><span class="oi oi-chevron-right"></span></span>&nbsp;
          <span class="all-next" @click="setPage(Math.ceil(totalMessages / perPage))"><span class="oi oi-chevron-right"></span><span class="oi oi-chevron-right"></span></span>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { helpersMixins } from '@/mixins/helpersMixins'
import { mapGetters, mapActions } from 'vuex'
import MessageActions from './MessageActions'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
import Tags from './Tags'
export default {
  name: 'Inbox',
  mixins: [helpersMixins],
  components: {
    MessageActions,
    SingleUserSelector,
    Tags
  },
  props: ['myInbox'],
  data () {
    return {
      messages: [],
      active: 0,
      page: 1,
      totalMessages: 0,
      perPage: 50,
      links: {},
      pageMin: 0,
      pageMax: 0,
      activeFolder: 'inbox',
      params: {},
      selectedIds: [],
      selectOptions: [],
      selectAll: false,
      totalInbox: 0,
      totalMine: 0,
      totalAssigned: 0,
      totalDrafts: 0,
      interval: null,
      loadingData: true,
      mobile: false,
      showUserSelect: false,
      assigned_user: {},
      inboxZero: false,
      previousCount: 0,
      loadingChanges: false,
      sortCol: null,
      sortOrder: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'messageSending', 'mailboxesCollection']),
    hasUserColumn () {
      if (this.myInbox || this.activeFolder !== 'inbox') {
        return true
      } else {
        return false
      }
    },
    showActions () {
      return this.selectedIds.length > 0
    }
  },
  created () {
    this.loadMailboxes()
    this.onResize()
    this.setFolder()
    this.setParams()
    this.getMessages()
    this.filterInbox(this.activeFolder)
    this.interval = setInterval(() => this.getMessages(), 25000)
    document.addEventListener('visibilitychange', this.toggleIntervals)
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    ...mapActions(['loadMailboxes']),

    mailboxName (id) {
      let mailbox = this.mailboxesCollection.filter(mailbox => mailbox.value === id)[0]
      return mailbox ? mailbox.label : ''
    },

    sort (column) {
      if (column === this.sortCol) {
        this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc'
      } else {
        this.sortCol = column
        this.sortOrder = 'asc'
      }
      let mod = this.sortOrder === 'desc' ? -1 : 1
      this.messages = this.messages.sort((a, b) => {
        if (this.sortCol === 'customer') {
          a = this.getCustomerName(a).toLowerCase()
          b = this.getCustomerName(b).toLowerCase()
          return a > b ? (1 * mod) : (-1 * mod)
        } else {
          return a[this.sortCol] > b[this.sortCol] ? (1 * mod) : (-1 * mod)
        }
      })
    },

    getCustomerName (message) {
      let name = ''
      if (message.customer) {
        name = message.customer.name ? message.customer.name : message.customer.email
      } else {
        name = message.from
      }
      return name || ''
    },

    getMessages (ids, search) {
      if (this.$route.name !== 'Inbox' && this.$route.name !== 'MyInbox' && this.$route.name !== 'InboxSubfolder') {
        return
      }
      if (ids) {
        this.params['ids'] = ids
      }
      if (this.$route.params.subfolder_id) {
        this.params['subfolder_id'] = this.$route.params.subfolder_id
      }
      this.previousCount = this.messages.length
      this.$http
        .get('/messages', { params: this.params })
        .then(function (response) {
          this.messages = response.data.messages
          this.active = response.data.total_active
          this.totalMessages = response.data.total_messages
          this.totalInbox = response.data.total_inbox
          this.totalMine = response.data.total_mine
          this.totalAssigned = response.data.total_assigned
          this.totalDrafts = response.data.total_drafts
          this.calcMinMax()
          this.loadingData = false
          this.loadingChanges = false
          let currentInbox = {
            totalActive: this.totalInbox,
            totalMine: this.totalMine,
            totalAssigned: this.totalAssigned,
            totalDrafts: this.totalDrafts,
            id: this.$route.params.id,
            name: response.data.team_name
          }
          if (this.$route.name === 'InboxSubfolder') {
            this.$store.dispatch('loadMailbox', this.$route.params.id)
          } else {
            this.$store.commit('setCurrentInbox', currentInbox)
          }
          this.selectOptions = response.data.messages.map(function (message) {
            return message.id
          })
          if (search) {
            this.params['ids'] = []
          }
          if (this.sortCol) {
            let column = this.sortCol
            this.sortCol = null
            this.sort(column)
          }
        }.bind(this))
        .catch(e => {
          this.loadingData = false
          console.log(e)
        })
    },

    setPage (num) {
      this.loadingData = true
      this.page = num
      this.params.page = this.page
      this.getMessages()
    },
    calcMinMax () {
      var newMin = (this.perPage * this.page) - this.perPage + 1
      if (this.messages.length > 0) {
        this.pageMin = newMin > 0 ? newMin : 1
        this.inboxZero = false
      } else {
        this.pageMin = 0
        this.triggerInboxZero()
      }
      var newMax = this.perPage * this.page
      if (newMax > this.totalMessages) {
        this.pageMax = this.totalMessages
      } else if (newMax < this.perPage) {
        this.pageMax = this.perPage
      } else {
        this.pageMax = this.perPage * this.page
      }
    },
    setParams () {
      var paramsHash
      if (this.myInbox === true) {
        paramsHash = {
          user_id: this.currentUser.id
        }
      } else if (this.activeFolder === 'inbox') {
        paramsHash = {
          mailbox_id: this.$route.params.id,
          assigned: false
        }
      } else if (this.activeFolder === 'mine') {
        paramsHash = {
          mailbox_id: this.$route.params.id,
          user_id: this.currentUser.id
        }
      } else if (this.activeFolder === 'assigned') {
        paramsHash = {
          mailbox_id: this.$route.params.id,
          assigned: true
        }
        if (this.assigned_user.id) {
          paramsHash.user_id = this.assigned_user.id
        }
      } else if (this.activeFolder === 'drafts') {
        paramsHash = {
          mailbox_id: this.$route.params.id,
          drafts: true
        }
      } else if (this.activeFolder === 'closed') {
        paramsHash = {
          mailbox_id: this.$route.params.id,
          status: 'closed'
        }
      }
      paramsHash.page = this.page
      if (this.params['ids']) {
        paramsHash['ids'] = this.params['ids']
      }
      this.params = paramsHash
    },

    filterInbox (folder) {
      if (this.activeFolder !== folder) {
        window.history.replaceState(null, null, '?q=' + folder)
        this.activeFolder = folder
        this.loadingData = true
        this.page = 1
        this.assigned_user = {}
        this.setParams(folder)
        this.getMessages()
      }
    },

    folderCountVariant (folder) {
      if (this.activeFolder !== folder) {
        return 'primary'
      } else {
        return 'light'
      }
    },

    setFolder () {
      if (this.$route.query.q) {
        var folderQuery = this.$route.query.q
        if (folderQuery === 'mine') {
          this.activeFolder = 'mine'
        } else if (folderQuery === 'assigned') {
          this.activeFolder = 'assigned'
        } else if (folderQuery === 'closed') {
          this.activeFolder = 'closed'
        } else if (folderQuery === 'drafts') {
          this.activeFolder = 'drafts'
        } else {
          this.activeFolder = 'inbox'
        }
      }
    },

    viewReplyClass (message) {
      if (Object.keys(message.message_state.editors).length > 1 || (Object.keys(message.message_state.editors).length === 1 && !message.message_state.editors[this.currentUser.id])) {
        return 'reply-flag'
      } else if (Object.keys(message.message_state.viewers).length > 1 || (Object.keys(message.message_state.viewers).length === 1 && !message.message_state.viewers[this.currentUser.id])) {
        return 'view-flag'
      }
    },

    toggleIntervals () {
      var vm = this
      if (document.hidden === true) {
        clearInterval(this.interval)
      } else {
        this.getMessages()
        this.interval = setInterval(function () {
          vm.getMessages()
        }, 25000)
      }
    },

    showViewerAvatar (id, i, message) {
      var draftIds = Object.keys(message.message_state.editors).map(id => parseInt(id))
      if (draftIds.includes(id)) {
        return false
      } else if ((id !== this.currentUser.id) && i < 3) {
        return true
      }
    },

    nextNode (node) {
      if (node.hasChildNodes()) {
        return node.firstChild
      } else {
        while (node && !node.nextSibling) {
          node = node.parentNode
        }
        if (!node) {
          return null
        }
        return node.nextSibling
      }
    },
    shiftClick (event, id) {
      var vm = this
      if (event.shiftKey) {
        let selection = window.getSelection()
        let range = selection.getRangeAt(0)
        let node = range.startContainer
        let endNode = range.endContainer
        let rangeNodes = []
        while (node && node !== endNode) {
          rangeNodes.push(node = this.nextNode(node))
        }
        rangeNodes.forEach(function (element) {
          element.checked = true
          if (element.value !== undefined) {
            vm.selectedIds.push(parseInt(element.value))
          }
        })
      }
    },
    onResize () {
      if (window.innerWidth > 767) {
        this.mobile = false
      } else {
        this.mobile = true
      }
    },
    triggerInboxZero () {
      this.inboxZero = true
      var dropConfetti = Math.floor(Math.random() * 10) > 4
      if (this.messages.length !== this.previousCount && dropConfetti) {
        this.$confetti.start({
          shape: 'rect',
          size: 10,
          dropRate: 10
        })
        var vm = this
        setTimeout(function () {
          vm.$confetti.stop()
        }, 5000)
      }
    }
  },
  watch: {
    '$route' () {
      this.activeFolder = 'inbox'
      this.selectedIds = []
      this.setParams()
      this.getMessages()
    },
    selectAll () {
      if (this.selectAll === true) {
        this.selectedIds = this.selectOptions
      } else {
        this.selectedIds = []
      }
    },
    assigned_user () {
      if (this.activeFolder === 'assigned') {
        this.loadingData = true
        this.setParams()
        this.getMessages()
        this.showUserSelect = false
      }
    }
  },

  mounted () {
    this.$root.$on('bulkMessageChangeSubmitted', () => {
      this.selectAll = false
      this.selectedIds = []
      this.setParams()
      this.getMessages()
    })
    this.$root.$on('searchPerformedForInbox', (ids) => {
      this.getMessages(ids, 'search')
    })
    this.$root.$on('filterInbox', (folder) => {
      this.filterInbox(folder)
    })
  },

  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.toggleIntervals)
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  }
}
</script>

<style scoped>
td span, td a p, td a, td img {
  user-select: none; /* CSS3 (little to no support) */
  -ms-user-select: none; /* IE 10+ */
  -moz-user-select: none; /* Gecko (Firefox) */
  -webkit-user-select: none; /* Webkit (Safari, Chrome) */
}
.inbox-table {
  width: 100%;
  table-layout: fixed;
  font-size: .8rem;
}
.inbox-table thead th {
  font-weight: 200;
  text-align: left;
  border-bottom: 1px solid #d6dde3;
}
.inbox-table th span {
  color: #93a1af;
}
.inbox-table td a {
  color: #4f5d6b;
  display: block;
  padding: 5px 10px 5px 0;
}
.inbox-table tr.pending td a {
  color: #4f5d6b;
}
.inbox-table tr.active td a {
  font-weight: bold;
  color: #000;
}
.inbox-table tr.selected td {
  background: #fffcf1;
}
.inbox-table .preview {
  color: #93a1af;
  font-weight: 400;
}
.conversation-column a:hover {
  text-decoration: none;
}
.conversation-column a .conversation-title:hover {
  text-decoration: underline;
}
td.conversation-column p, td.conversation-column span {
  line-height: 1.5em;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.inbox-table .conversation-column {
  width: 50% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  padding-right: 20px;
}
.inbox-table td {
  text-align: left;
  border-bottom: 1px solid #d6dde3;
  padding: 0;
}
.inbox-table tr .check-column {
  padding: 5px 5px 5px 10px;
}
.inbox-table th .check-column {
  padding: 5px 5px 5px 12px;
}
.inbox-table .customer-column {
  width: 15%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inbox-table .time-column {
  width: 13%;
}
.inbox-table .ticket-id-column {
  width: 10%;
}
.inbox-table .mailbox-column {
  width: 2%;
}
.inbox-table .user-column {
  width: 5%;
  position: relative;
}
.reply-tag {
  background: #e2e2e2;
  border: 1px solid #cad0d6;
  color: #909ba5;
}
.reply-tag-merged {
  background: #ff0000;
  border: 1px solid #cad0d6;
  color: #ffffff;
}
.topic-tag {
  padding: 0 5px;
}
.totals-row {
  float: left;
  color: #7a8da0;
}
.total-conversation, .total-active, .range1, .range2 {
  font-weight: bold;
  color: #676d7a;
}
.viewing-text {
  visibility: visible;
}
.pagination-row {
  float: right;
}
span.oi {
  color:#7a8da0;
}
.all-previous, .previous {
  visibility: visible;
}
.all-next, .next {
  visibility: visible;
}
.user-avatar {
  border-radius: 50%;
  height: 30px;
  width: 30px;
}
.fa-tasks {
  opacity: .5;
}
.icon-missing {
  color: #57B2CD;
  font-size: 30px;
}
.actions-wrapper {
  display: inline-block;
  background: #FFFFFF;
  height: 55px;
  padding: 0;
  border-radius: 5px;
  position: fixed;
  margin-left: -10%;
  border: 1px solid #DBDBDB;
  box-shadow: 0 10px 200px 10px rgba(0,0,0,.4);
}
.nav-closed .actions-wrapper {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
.nav-open .actions-wrapper {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
ul.inbox-actions {
  list-style: none;
  margin: 0;
  height: 54px;
  position: relative;
  margin: 0px;
  display: flex;
  justify-content: center;
  padding: 7px 5px;
  width: 100%;
}
.closed-tab > .nav-link {
  color: #6C757D;
}
.closed-tab > .nav-link.active {
  color: #FFF;
  background-color: #6C757D;
}
span .oi {
  cursor: pointer;
}
.inbox-table tr {
  border-bottom: 1px solid #d6dde3;
}
.inbox-table .td-flags {
  vertical-align: top !important;
}
.inbox-table tbody td .message-flags {
  display: block;
  position: relative;
}
.inbox-table tbody td .flag {
  display: block;
  position: relative;
}
.inbox-table div.flag:before {
  border-bottom: 12px solid transparent;
  border-top: 0 solid transparent;
  content: "";
  display: block;
  height: 0;
  position: absolute;
  top: 0;
  width: 0;
}
col.td-flags {
  width: 2px;
}
col.check-column {
  width: 40px;
}
.message-flags .view-flag:before {
  border-left: 12px solid #F5B126;
}
.message-flags .reply-flag:before {
  border-left: 12px solid #E52F28;
}
.user-avatar.viewing {
  border: 1px solid #F5B126;
}
.user-avatar.replying {
  border: 1px solid #E52F28;
}
div.user-select {
  position: fixed;
  min-width: 250px;
  right: 10px;
  z-index: 1;
}
.inbox-wrapper {
  margin-top: 15px;
}
@media (max-width: 767px) {
  .inbox-table tr td, .inbox-table .reply-column, .inbox-table .conversation-column, .inbox-table .customer-column, .inbox-table .user-column, .inbox-table .time-column {
    width: auto !important;
    border-bottom: none;
    padding-right: 0;
  }
  .inbox-table .user-column, .inbox-table .conversation-column, .inbox-table .customer-column, .inbox-table .reply-column {
    float: left;
    max-width: 80vw;
  }
  .inbox-table .time-column {
    float: right;
  }
  .inbox-table .user-column {
    padding-bottom: 5px;
  }
  .inbox-table .reply-column {
    float: right;
  }
}
</style>

<style>
div.popover.fade.show.bs-popover-left, div.popover.fade.bs-popover-left {
  left: -50px !important;
}

.inbox-actions > .actions-menu-wrapper > .actions > li > a > span {
  color: #9A9A9A;
}
.inbox-actions > .actions-menu-wrapper > .message-bar.actions > li > .btn-group.b-dropdown.dropdown > button > a > span {
  color: #9A9A9A;
}
.loading {
  height: 100vh;
  padding: 5vw;
  text-align: center;
  font-size: calc(~"15px + 1.5vw");
  background-color: #fff;
}
.loading-changes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
}
.fade-transition {
  transition: opacity 8000ms ease;
}
.fade-transition.loading {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 15px;
  right: 15px;
}
.fade-enter,
.fade-leave {
  opacity: 0;
}
.gray {
  background: #f2f3f4;
 }
.green {
   background: #4dbd7c;
 }
.blue {
   background: #2f44d6;
 }
.orange {
  background: #f98b33;
 }
.purple {
  background: #7e81e7;
}
.red {
  background: #e02e28;
}
.inbox-zero {
  margin-top: 10%;
}
.big-zero {
  color: #57B2CD;
  font-size: 10rem;
}
@media (max-width: 767px) {
  .bs-popover-auto[x-placement^=left] .arrow:after, .bs-popover-auto[x-placement^=left] .arrow:before, .bs-popover-left .arrow:after, .bs-popover-left .arrow:before {
    border-width: 0;
  }

  div.popover.fade.bs-popover-left, div.popover.fade.show.bs-popover-left {
    margin-left: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Inbox.vue